import { connect } from 'react-redux';
import { constant } from '../../../Utils/constants';
import React, { Fragment, useState, useEffect } from 'react';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';
import { Form, Select, Popconfirm, Tooltip, Collapse,Button } from 'antd';
import { getToolsList, checkLimit } from '../../../Utils/FormCalls';
import { PlusOutlined, DeleteOutlined, QuestionCircleOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Panel } = Collapse;

//@ATT:this was created to make nested dynamic elements! This is hard!

const ToolsFormFunction = ({
  fields,
  add,
  remove,
  SrId,
  WoId,
  EmailId,
  MobileId,
  SlackId,
  translationCa,
  formObject,
  onNotificationChange,
  warningTypeList,
  notificationTypeList,
  usersList,
  conditionMonitorRef
}) => {
  const [toolsList, setToolList] = useState([]);
  const translationCache = translationCa || {};
  useEffect(() => {
    (async () => {
      try {
        let response = await getToolsList();
        setToolList(response ? response.data : toolsList);
      } catch (e) {
        return {};
      }
    })();
  }, []);

  const getDisableStatus = (index, notification) => {
    let selectedNotif =
      formObject &&
      formObject.Warnings &&
      formObject.Warnings[index] &&
      formObject.Warnings[index].NotificationTypeId
        ? formObject.Warnings[index].NotificationTypeId
        : [];
    if (selectedNotif && Array.isArray(selectedNotif)) {
      if (
        notification &&
        notification.Key &&
        notification.Key === 'ServiceRequest' &&
        selectedNotif.includes(WoId)
      ) {
        //If SelectedNotification has WOId , disable SR
        return true;
      } else if (
        notification &&
        notification.Key &&
        notification.Key === 'WorkOrder' &&
        selectedNotif.includes(SrId)
      ) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };
  return (
    <Fragment>
      <Form.Item>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Button
            type="primary"
            // theme={themeSettings}
            // style={{ background: '#29415a', color: '#fff' }}
            onClick={() => add()}>
            <PlusOutlined /> {translation(translationCache, constant.addWarning)}
          </Button>
        </div>
      </Form.Item>
      {fields && Array.isArray(fields) && fields.length > 0 ? (
        <Collapse accordion defaultActiveKey={[]}>
          {fields.map((field, index2) => (
            <Panel
              key={index2}
              header={
                <div style={{ fontWeight: 'bold' }}>
                  {translation(translationCache, `Warning ${index2 + 1}`)}
                </div>
              }
              extra={
                <Popconfirm
                  title={translation(
                    translationCache,
                    'Are you sure that you want to  delete the Warning ?'
                  )}
                  icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                  onConfirm={() => remove(field.name)}
                  okText="Yes"
                  cancelText="No">
                  {' '}
                  <Tooltip title={translation(translationCache, 'Delete')} placement="bottom">
                    <DeleteOutlined />
                  </Tooltip>
                </Popconfirm>
              }>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Form.Item
                  {...fields}
                  label={translation(translationCache, constant.warningType)}
                  style={{ flex: '50%' }}
                  labelCol={{ flex: '130px' }}
                  {...field}
                  name={[field.name, 'WarningTypeId']}
                  fieldKey={[field.fieldKey, 'WarningTypeId']}
                  key={index2}
                  rules={[{ required: true }]}>
                  <Select
                    style={{ width: '70%' }}
                    placeholder={translation(translationCache, 'Select Warning Type')}>
                    {warningTypeList &&
                      Array.isArray(warningTypeList) &&
                      warningTypeList.map((warning, index) => {
                        return (
                          <Option
                            key={index}
                            value={warning.Value}
                            disabled={
                              conditionMonitorRef &&
                              conditionMonitorRef.current &&
                              conditionMonitorRef.current.getFieldValue() &&
                              conditionMonitorRef.current.getFieldValue().Warnings &&
                              conditionMonitorRef.current
                                .getFieldValue()
                                .Warnings.filter(
                                  (text) => text && text.WarningTypeId === warning.Value
                                ).length > 0
                                ? true
                                : false
                            }>
                            {' '}
                            {warning.Key}{' '}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>

                <Form.Item
                  label={translation(translationCache, constant.notificationType)}
                  {...fields}
                  style={{ flex: '50%' }}
                  labelCol={{ flex: '130px' }}
                  name={[field.name, 'NotificationTypeId']}
                  fieldKey={[field.fieldKey, 'NotificationTypeId']}
                  key={index2}
                  rules={[{ required: true }]}>
                  <Select
                    mode="multiple"
                    showArrow={true}
                    style={{ width: '70%' }}
                    placeholder={translation(translationCache, 'Select Notification Type')}
                    onChange={(value) =>
                      onNotificationChange(value, 'NotificationTypeId', index2, 'Warnings')
                    }>
                    {notificationTypeList &&
                      Array.isArray(notificationTypeList) &&
                      notificationTypeList.map((notification, index) => {
                        return (
                          <Option
                            key={index}
                            value={notification.Value}
                            disabled={getDisableStatus(index2, notification)}>
                            {notification.Key}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>

                <Form.Item
                  label={translation(translationCache, constant.UpperLimit)}
                  // disabled={true}
                  {...fields}
                  style={{ flex: '50%' }}
                  labelCol={{ flex: '130px' }}
                  name={[field.name, 'UpperLimit']}
                  fieldKey={[field.fieldKey, 'UpperLimit']}
                  key={index2}
                  rules={[
                    { required: true },
                    {
                      validator: (_, value) =>
                        checkLimit(
                          value,
                          'UpperLimit',
                          conditionMonitorRef &&
                            conditionMonitorRef.current &&
                            conditionMonitorRef.current.getFieldValue() &&
                            conditionMonitorRef.current.getFieldValue().Warnings &&
                            conditionMonitorRef.current.getFieldValue().Warnings[index2]
                            ? conditionMonitorRef.current.getFieldValue().Warnings[index2]
                            : {},
                          // formObject.Warnings
                          //   ? formObject.Warnings[index2]
                          //   : {},
                          {
                            validateField: 'LowerLimit',
                            operator: 'greater'
                          }
                        )
                    }
                  ]}>
                  <InputComponent
                    placeholder={translation(translationCache, 'Input UpperLimit')}
                    style={{ width: '70%' }}
                  />
                </Form.Item>
                <Form.Item
                  label={translation(translationCache, constant.LowerLimit)}
                  // disabled={true}
                  {...fields}
                  style={{ flex: '50%' }}
                  labelCol={{ flex: '130px' }}
                  name={[field.name, 'LowerLimit']}
                  fieldKey={[field.fieldKey, 'LowerLimit']}
                  key={index2}
                  rules={[
                    { required: true },
                    {
                      validator: (_, value) =>
                        checkLimit(
                          value,
                          'LowerLimit',
                          // formObject.Warnings
                          //   ? formObject.Warnings[index2]
                          //   : {},
                          conditionMonitorRef &&
                            conditionMonitorRef.current &&
                            conditionMonitorRef.current.getFieldValue() &&
                            conditionMonitorRef.current.getFieldValue().Warnings &&
                            conditionMonitorRef.current.getFieldValue().Warnings[index2]
                            ? conditionMonitorRef.current.getFieldValue().Warnings[index2]
                            : {},
                          {
                            validateField: 'UpperLimit',
                            operator: 'less'
                          }
                        )
                    }
                  ]}>
                  <InputComponent
                    placeholder={translation(translationCache, 'Input LowerLimit')}
                    style={{ width: '70%' }}
                  />
                </Form.Item>

                {(formObject &&
                  formObject.Warnings &&
                  formObject.Warnings[index2] &&
                  formObject.Warnings[index2].NotificationTypeId &&
                  formObject.Warnings[index2].NotificationTypeId.includes(EmailId)) ||
                (formObject &&
                  formObject.Warnings &&
                  formObject.Warnings[index2] &&
                  formObject.Warnings[index2].NotificationTypeId &&
                  formObject.Warnings[index2].NotificationTypeId.includes(MobileId)) ? (
                  <>
                    <Form.Item
                      style={{ flex: '50%' }}
                      labelCol={{ flex: '130px' }}
                      label={translation(translationCache, constant.user)}
                      // {...restField}
                      name={[field.name, 'Emails']}
                      rules={[{ required: true }]}>
                      <Select
                        showArrow={true}
                        mode="multiple"
                        placeholder={translation(translationCache, 'Select User')}
                        style={{ width: '70%' }}>
                        {usersList &&
                          Array.isArray(usersList) &&
                          usersList.map((item, index) => {
                            return (
                              <Option key={index} value={item.Email}>
                                {' '}
                                {item.FirstName}{' '}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    <Form.Item style={{ width: '100%', flex: '50%' }}>
                      <InputComponent style={{ display: 'none' }} />
                    </Form.Item>
                  </>
                ) : null}
                {formObject &&
                formObject.Warnings &&
                formObject.Warnings[index2] &&
                formObject.Warnings[index2].NotificationTypeId &&
                formObject.Warnings[index2].NotificationTypeId.includes(SlackId) ? (
                  <Form.Item
                    style={{ flex: '50%' }}
                    labelCol={{ flex: '130px' }}
                    label={translation(translationCache, constant.channel)}
                    name={[field.name, 'ChannelName']}
                    rules={[
                      { required: true, message: 'Please Input Channel!' }
                      // { pattern: new RegExp(/^[A-Za-z0-9]*$/),
                      //   message: 'field does not accept special characters' }
                    ]}>
                    <InputComponent
                      //maxLength={30}
                      placeholder={translation(translationCache, 'Input Channel')}
                      style={{ width: '70%' }}
                    />
                  </Form.Item>
                ) : null}
                <Form.Item {...fields} style={{ flex: '50%' }}>
                  <InputComponent style={{ width: '70%', display: 'none' }} />
                </Form.Item>
              </div>
            </Panel>
          ))}
        </Collapse>
      ) : null}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps
});

const ToolsForm = connect(mapStateToProps, null, mergeProps)(ToolsFormFunction);

export { ToolsForm };
